var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { Constants } from './Constants';
import { isTokenExpired } from './API';
import { refreshToken } from '@/containers/pages/OnBoarding/Login/LoginService';
const BASE_URL = Constants.REACT_APP_API_BASE_URL_STORE; // base url
const axiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'x-api-version': 1
    },
    // withCredentials: true, // Include credentials such as cookies in the request
});
axiosInstance.interceptors.request.use((config) => __awaiter(void 0, void 0, void 0, function* () {
    const authToken = localStorage.getItem("accessToken");
    if (authToken) {
        // Check if the access token has expired
        if (isTokenExpired(authToken)) {
            try {
                // Attempt to refresh the token
                const refreshedToken = yield refreshToken();
                // Update the authorization header with the new token
                config.headers['Authorization'] = `Bearer ${refreshedToken}`;
            }
            catch (error) {
                // Handle token refresh error
                console.error('Error refreshing token:', error);
                // Optionally, redirect the user to the login page or perform other actions
            }
        }
        else {
            // Token is still valid, include it in the request header
            config.headers['Authorization'] = `Bearer ${authToken}`;
        }
    }
    return config;
}), (error) => {
    // Handle request error
    return Promise.reject(error);
});
const apiLocal = {
    get: (endpoint, payload) => axiosInstance.get(endpoint, { params: payload }).then((response) => response.data),
    post: (endpoint, payload) => axiosInstance.post(endpoint, payload).then((response) => response.data),
    put: (endpoint, payload) => axiosInstance.put(endpoint, payload).then((response) => response.data),
    delete: (endpoint) => axiosInstance.delete(endpoint).then((response) => response.data),
    downloadLabel: (endpoint, payload) => axiosInstance.post(endpoint, payload, { responseType: 'blob' }).then((response) => response.data),
};
export default apiLocal;
